import React from "react";
import { useTranslation } from "react-i18next";
import { IoCheckmarkCircle } from "react-icons/io5";
import { Ticket } from "../../../../../models/Ticket";
import EAProgressBar from "../../../../shared/ProgressBar/EAProgressBar";
import { getUsageSectionData, isTicketUsedUp } from "../../../../../utils/TicketPassHelper";

interface IProps {
  pass: Ticket;
}

/**
 * Sekcja "Wykorzystanie" w szczegółach biletu/karnetu.
 * Widoczność i treść wynikają z getUsageSectionData (flaga shouldShowUsageSection).
 * Pasek tylko przy puli większej niż 1 wejście — przy jednym wejściu zostaje sama narracja.
 * Gdy bilet/karnet jest już wykorzystany, sekcja jest wyszarzona.
 */
const DetailsUsageProgress: React.FC<IProps> = ({ pass }) => {
  const { t } = useTranslation();
  const usage = getUsageSectionData(pass);

  if (usage.mode === "none") {
    return null;
  }

  const isUsed = isTicketUsedUp(pass);
  const showProgressBar = usage.total > 1;

  return (
    <div className="ticket-details__usage-section">
      <div className={`ticket-details__usage-box ${isUsed ? "ticket-details__usage-box--used" : ""}`}>
        <div className="ticket-details__usage-box-header">
          <h5>{usage.title}</h5>
          {isUsed && (
            <span className="ticket-details__usage-used-badge">
              <IoCheckmarkCircle /> {t("wykorzystany")}
            </span>
          )}
        </div>
        {showProgressBar && <EAProgressBar currentStep={usage.current} totalSteps={usage.total} />}

        {usage.mode === "validity" ? (
          <div className="ticket-details__usage-range">
            <span className="ticket-details__usage-description">{usage.rangeStartLabel}</span>
            <span className="ticket-details__usage-description">{usage.rangeEndLabel}</span>
          </div>
        ) : (
          usage.primaryDescription && (
            <span className="ticket-details__usage-description">{usage.primaryDescription}</span>
          )
        )}

        {usage.secondaryDescription && (
          <span className="ticket-details__usage-description ticket-details__usage-description--secondary">
            {usage.secondaryDescription}
          </span>
        )}
      </div>
    </div>
  );
};

export default DetailsUsageProgress;
